export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0"},{"hid":"description","name":"description","content":" "},{"hid":"og:description","name":"og:description","property":"og:description","content":" "},{"hid":"og:url","name":"og:url","property":"og:url","content":" "},{"hid":"og:locale","name":"og:locale","property":"og:locale","content":" "},{"hid":"og:image","name":"og:image","property":"og:image","content":"https://7bitcasino.com/image-cdn/7bit_logo_1200x630_full_720_8832d1d66d.png"},{"hid":"og:image:alt","name":"og:image:alt","property":"og:image:alt","content":"https://7bitcasino.com"},{"name":"google-site-verification","content":"KQO_R9KD7Dpns1z-7lHGGvUph3sAFczttWu6l8M-BRQ"},{"rel":"preconnect","href":"/image-cdn/"},{"rel":"dns-prefetch","href":"/image-cdn/"},{"name":"theme-color","content":"#0a0c15"}],"link":[{"rel":"preload","type":"font/woff","href":"/fonts/NunitoSans_7pt-Bold.woff","as":"font","crossorigin":"anonymous"},{"rel":"preload","type":"font/woff","href":"/fonts/NunitoSans_7pt-ExtraBold.woff","as":"font","crossorigin":"anonymous"},{"rel":"preload","type":"font/woff","href":"/fonts/NunitoSans_7pt-Light.woff","as":"font","crossorigin":"anonymous"},{"rel":"preload","type":"font/woff","href":"/fonts/NunitoSans_7pt-Medium.woff","as":"font","crossorigin":"anonymous"},{"rel":"preload","type":"font/woff","href":"/fonts/NunitoSans_7pt-Regular.woff","as":"font","crossorigin":"anonymous"},{"rel":"manifest","href":"/manifest.webmanifest"}],"style":[],"script":[{"children":"\n            window.addEventListener('beforeinstallprompt', function(e) {\n              e.preventDefault();\n              const event = new CustomEvent('pwa:deferredPrompt', { detail: e });\n              window.dispatchEvent(event);\n            });\n          ","type":"text/javascript"}],"noscript":[],"title":" "}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false